<template>
  <section class="!font-sanstc">
    <Intro />
    <VaccinePromotion />
    <VaccinePromotionDesc />
    <ContactInfo />
    <Appointment />
    <AppointmentProcedure />
  </section>
</template>
<script setup lang="ts">
import Intro from "@/components/bivalentVaccine/BivalentVaccineIntro.vue";
import VaccinePromotion from "@/components/bivalentVaccine/VaccinePromotion.vue";
import VaccinePromotionDesc from "@/components/bivalentVaccine/VaccinePromotionDesc.vue";
import ContactInfo from "@/components/bivalentVaccine/ContactInfo.vue";
import Appointment from "@/components/bivalentVaccine/Appointment.vue";
import AppointmentProcedure from "@/components/bivalentVaccine/AppointmentProcedure.vue";

import { computed, onMounted, onUnmounted, ref, toRefs } from "vue";
import { useI18n } from "vue-i18n";

const { t, locale } = useI18n();

onMounted(async () => {
  console.log("change lang to cn");
  locale.value = "cn";
});

onUnmounted(async () => {
  console.log("change lang to en");
  locale.value = "en";
});
</script>

